import Header from "../Components/Header"
import Footer from "../Components/Footer"
import { MultiTypeBlock1, CheckboxBlocks, SubmitAndClear, MultiTypeBlock2, MultiTypeBlock3, MultiCheckboxBlocks, ZoneCheckboxes} from "../Components/FilterMemuBlocks"
import { FilterTabFrame, FilterTable } from "../Components/FilterFrame"
import { resolveFilterLeagueData, resolveFilterResult, wrapFilterRequestData } from "../Utils/DataProcess"
import { useEffect, useState } from "react"
import { useForm, FormProvider } from 'react-hook-form'
import { api_getFilterLeagueData, api_getFilterResult } from "../API/axios"
import { MessageModal } from "../Components/Modals/MessageModal"
import { resolveBubbleChartData } from "../Utils/ChartDataProcess"
import Loading from "../Components/Loading"

const menuRow1 = [{
  title:"Year", key: "Year", options:['', 2023, 2022]}, {title:"Umpire", key: "Umpire",
  options:["", "林金達", "紀華文", "蘇建文", "羅鈞鴻", "邱景彥", "彭楚雲", "蔡豐澤", "江春緯", "吳家維", "王俊宏", "張展榮", "楊崇煇", "尤志欽", "陳均瑋"
  ]
}]
const menuRow2 = {
  title:"Call", key: "PCList",
  cols: [
    {colClass:"col3", boxes:["Ball", "Swing & Miss", "Called Strike"]},
    {colClass:"col3", boxes:["Foul", "In Play", "All Swings"]}
  ]
}
const ruleRow2 = {
  "All Swings": ["Swing & Miss", "Foul", "In Play"]
}

const menuRow3 = {
  title:"Hit Type", key: "HTList",
  cols: [
    {colClass:"col3", boxes:["Ground", "Line", "All Fly"]},
    {colClass:"col3", boxes:["Pop-up", "Fly"]}
  ]
}
const ruleRow3 = {
  "All Fly": ["Pop-up", "Fly"]
}

const menuRow4 = {
  title:"Result", key: "PRList",
  cols: [
    {colClass:"col3", boxes:["Hit", "Single", "Double"]},
    {colClass:"col3", boxes:["", "Triple", "Homerun"]},
    {colClass:"col3", boxes:["Outs", "Fly Out", "Ground Out"]},
    {colClass:"col3", boxes:["", "Double Play", "Triple Play"]},
    {colClass:"col3", boxes:["Error", "Sac-Fly", "Sac-Bunt"]},
  ]
}

const ruleRow4 = {
  "Hit": ["Single", "Double", "Triple", "Homerun"],
  "Outs": ["Fly Out", "Ground Out", "Double Play", "Triple Play"]
}

const menuRow5 = {
  title:"Hardness", key: "Hardness",
  cols: [
    {colClass:"col3", boxes:["HARD","MED", "SOFT"]},
    {colClass:"col3 font-small", boxes:["Barrels","Solid Contact", "Flares & Bumers"]},
    {colClass:"col3 font-small", boxes:["Topped", "Hit under","Weak Contact"]}
  ]
}

const menuRow6 = {
  title:"Counts", key: "BSList",
  cols: [
    {colClass:"col3", boxes:["Even", "Pitcher Lead", "Batter Lead"],},
    {colClass:"col3", boxes:["0-0", "1-1", "2-2"]},
    {colClass:"col3", boxes:["0-1", "0-2", "1-2"]},
    {colClass:"col3", boxes:["1-0", "2-0", "2-1"]},
    {colClass:"col3", boxes:["3-0", "3-1", "3-2"]},
  ]
}
const ruleRow6 = {
  "Pitcher Lead": ["0-1", "0-2", "1-2"],
  "Batter Lead": ["1-0", "2-1", "3-2", "2-0", "3-0", "3-1"],
  "Even": ["0-0", "1-1", "2-2"]
}

const menuRow7 = {
  title:"Zone", key: "ZPointList",
  cols: [
    {colClass:"col3", boxes:["Inside","Middle", "Outside"],},
    {colClass:"col3", boxes:["High","Medium", "Low"]},
  ]
}

const leagueAvg = {
  discipline: [
    {title: "聯盟平均", data: ['-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-']}
  ],
  score: [
    {title: "聯盟平均", data: ['-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-']}
  ],
  hit: [
    {title: "聯盟平均", data: ['-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-']}
  ]
}

const sheet = {
  discipline: {
    headers: ['Type', 'Total#','Total%','Strike#','Strike%','Zone#','Zone%','Swing#','Swing%','StrSw%','Z-Swing%','O-Swing%','Contact#','Contact%','Z-Contact%','O-Contact%','Whiff#','Whiff%','Swtr%','In-Play#','In-Play%'],
    data: [
      {title: "", data:['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '']}
    ]
  }, 
  score: {
    headers: ['Type', 'Avg', 'Avg L', 'Avg R', 'OBP', 'SLG', 'OPS', 'BABIP', 'K%', 'BB%', 'G', 'PA', 'AB', 'H', 'XBH', 'HR', 'TB', 'K', 'BB'],
    data: [
      {title: "", data:['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '']}
      //{title: "直球", data:[0.233, 0.222, 0.267, 0.442, 0.452, 0.894, 0.288, '10%', '5%', 12, 109, 90, 22, 7, 1, 17, 11, 6]}
    ]
  },
  hit: {
    headers: ['Type', 'GB%', 'LD%', 'FB%', 'IFFB%', 'HardHit%', 'SweetSpot%', 'Weak%', 'Topped%', 'Under%', 'Flare/Burner', 'Solid%', 'Barrel%', 'Soft%', 'Med%', 'Hard%', 'Pull%', 'Straight%', 'Oppo%'],
    data: [
      {title: "", data:['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '']}
      //{title: "滑球", data:['20%', "50%", "60%", "15%", "20%", "30%", "10%", "15%", "60%", "15%", "20%", "30%", "10%", "15%", "10%", '10%', '10%']}
    ]
  }
}
const ptypes = [["Fastball", "Sinker", "SFF"], ["Slider", "Curve", "Cutter"], ["Change-up", "Splitter", "Slow Curve"], ["Knuckle", "Others"]]

const clearField = {
  Year: "",
  Batter: "",
  BatSList: false,
  Pitcher: "",
  Catcher: "",
  Umpire: "",
  OList: false,
  OBList: false,
  TagPList: false,
  ZBList: false,
  Hardness: false,
}


const Filter = () => {
  const [graphMode, setGraphMode] = useState('pitch')
  const [tableMode, setTableMode] = useState('discipline')
  const [modalMsg, setModalMsg] = useState('')
  const [modalVis, setModalVis] = useState(false)
  const [chartData, setChartData] = useState({zone: {datasets: []}, field: {datasets: []}})
  const [sheetData, setSheetData] = useState(sheet)
  const [leagueSheet, setLeagueSheet] = useState(leagueAvg)
  const [loading, setLoading] = useState(false)
  const methods = useForm()

  
  /*
  useEffect(() => {
    const loadPreData = async () => {
      const load_res = await api_getFilterLeagueData()
      if (load_res.status === 'error') {
        setLoading(false)
        setModalMsg(load_res.message)
        setModalVis(true);
        return false
      } else {
        return resolveFilterLeagueData(load_res.data[0])
      }
    }
    loadPreData().then((load_data) => {
      if (!load_data) return;
      let lgAvg = { ...leagueAvg }
      lgAvg.discipline[0].data = load_data.discipline
      lgAvg.score[0].data = load_data.score
      lgAvg.hit[0].data = load_data.hit
      setLeagueSheet(lgAvg)
      setLoading(false)
    })
  }, [])
  */

  const handleOnSubmit = async (data) => {
    setLoading(true)
    let pdata = wrapFilterRequestData(data)
    const filterRes = await api_getFilterResult({...pdata, League: "v7UKplSBRrrDN8bShc8XzcolcnOerx"})
    if (filterRes.status === 'error') {
      setLoading(false)
      setModalMsg(filterRes.message)
      setModalVis(true);
    } else { // TODO: success operations
      if (filterRes.data.length === 0) {
        setLoading(false)
        setModalMsg("No available data")
        setModalVis(true);
      } else {
        try {
          let { chart, ...table } = resolveFilterResult(filterRes.data, pdata.Pitcher!==undefined, pdata.Batter!==undefined)
          let chartResData = resolveBubbleChartData(chart)
          let newTable = {...sheetData}
          newTable.discipline.data = table.discipline
          newTable.score.data = table.score
          newTable.hit.data = table.hit
          setChartData(chartResData)
          setSheetData(newTable)
          setLoading(false)
        } catch (e) {
          console.log(e)
          setLoading(false)
          setModalMsg("Error occurs, please contact us")
          setModalVis(true);
        }
      }
    }
    // methods.reset(clearField)
    window.scrollTo(0, 0)
  }
  return (
    <FormProvider {...methods}>
      <MessageModal type='error' message={modalMsg} visible={modalVis} setVisible={setModalVis} /> 
      <Loading visible={loading} />
      <Header />
      <div className="wrapper">
        <form className="filter_menu" onSubmit={methods.handleSubmit(handleOnSubmit)}>
          <MultiTypeBlock1 contents={menuRow1} />
          <MultiCheckboxBlocks content={menuRow2} rule={ruleRow2} />
          <MultiCheckboxBlocks content={menuRow3} rule={ruleRow3} />
          <MultiCheckboxBlocks content={menuRow4} rule={ruleRow4} />
          <CheckboxBlocks content={menuRow5} />
          <MultiTypeBlock2 />
          <MultiCheckboxBlocks content={menuRow6} rule={ruleRow6} />
          <ZoneCheckboxes />
          <MultiTypeBlock3 content={ptypes} />
          <SubmitAndClear clearField={clearField} />
        </form>
        <div className="filter">
          <FilterTabFrame ballData={chartData} mode={graphMode} setMode={setGraphMode} />
          <FilterTable sheet={sheetData} dSheet={null} mode={tableMode} setMode={setTableMode} />
        </div>
      </div>
      <Footer />
    </FormProvider>
  )
}

export default Filter